import React from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'
import { GoogleLogin } from 'react-google-login'
import classNames from 'classnames/bind'

import config from 'config'
import { MainButton } from 'components/button'
import { localize } from 'helpers/translator'

import styles from './google_login_button.scss'
import googleIcon from 'assets/views/signup/google-icon.svg'

const cx = classNames.bind(styles)

const GoogleLoginButton = props => {

	const handleSuccess = response => {
		let responseData
		if (props.isOfflineMode) {
			responseData = response.profileObj
			response.disconnect()
		} else {
			responseData = response.tokenObj
		}
		props.onSuccess(responseData)
	}

	const handleFailure = response => {
		props.onFailure(response)
	}

	return (
		<GoogleLogin
			clientId={config.googleDrive.clientId}
			render={renderProps => (
				<MainButton
					onClick={renderProps.onClick}
					disabled={renderProps.disabled}
					pill={true}
				>
					<Isvg src={googleIcon} cacheGetRequests={true} className={cx('icon')} />
					{ localize('logIn_logInWithGoogle') }
				</MainButton>
			)}
			onSuccess={handleSuccess}
			onFailure={handleFailure}
			cookiePolicy={'single_host_origin'}
		/>
	)
}

GoogleLoginButton.propTypes = {
	isOfflineMode: PropTypes.bool,
	onSuccess: PropTypes.func,
	onFailure: PropTypes.func,
}

GoogleLoginButton.defaultProps = {
	isOfflineMode: false,
	onSuccess: () => {},
	onFailure: () => {},
}

export default CSSModules(GoogleLoginButton, styles, {allowMultiple: true})
